import { useMutation } from '@tanstack/react-query';
import { transformLifeAreaSectionToGoal } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

export type TransformLifeAreaSectionToGoalMutationOptions = {
  lifeArea: LifeArea;
  sectionId: ID;
};

export const useTransformLifeAreaSectionToGoalMutation = () =>
  useMutation({
    mutationFn: ({
      lifeArea,
      sectionId,
    }: TransformLifeAreaSectionToGoalMutationOptions) =>
      transformLifeAreaSectionToGoal(sectionId, lifeArea),
  });
